import { useEffect, useState } from "react";
import instance from "./customInstance";

/**
 * useOptimisticFetch hook
 * @param {string} url - API endpoint
 * @param {any} initialData - optional default/optimistic data
 */
const useOptimisticFetch = (url, initialData = []) => {
  const [data, setData] = useState(initialData);
  const [loading, setLoading] = useState(!initialData?.length); // only loading if no initial data
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true; // to avoid setting state on unmounted component

    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        const { data: response } = await instance.get(url);
        if (isMounted) {
          setData(response);
          setLoading(false);
        }
      } catch (err) {
        if (isMounted) {
          setError(err.message || "Something went wrong");
          setLoading(false);
        }
      }
    };

    fetchData();

    return () => {
      isMounted = false; // cleanup
    };
  }, [url]);

  return {
    data,
    setData, // optional: allow manual optimistic updates
    loading,
    error,
  };
};

export default useOptimisticFetch;
